import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './GetCompanyInfo.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCompanyInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
}>;


export type GetCompanyInfoQuery = (
  { __typename?: 'Query' }
  & { company?: Types.Maybe<(
    { __typename?: 'Company' }
    & Pick<Types.Company, 'id' | 'contractPackageName' | 'createdAt' | 'hasXamAccount' | 'companySize' | 'companySizeId' | 'companyName'>
    & { userContext?: Types.Maybe<(
      { __typename?: 'CompanyUserContext' }
      & Pick<Types.CompanyUserContext, 'userRole'>
    )>, industry?: Types.Maybe<(
      { __typename?: 'Industry' }
      & Pick<Types.Industry, 'id' | 'localizationValue'>
    )> }
  )> }
);



/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(Operations.GetCompanyInfo, options);
      }
export function useGetCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(Operations.GetCompanyInfo, options);
        }
export type GetCompanyInfoQueryHookResult = ReturnType<typeof useGetCompanyInfoQuery>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLazyQuery>;
export type GetCompanyInfoQueryResult = Apollo.QueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;